import ReactMarkdown from "react-markdown";

export function NewlineText(props) {
    const text = props.text;
    return text.split('\n').map((str,index) =>
    <div className={props.className} key={index}>
        <ReactMarkdown>{str}</ReactMarkdown>
    </div>);
}

export function MultiLineIndexText(props) {
    const text = props.text;
    return text.split('\n').map((str, index) => {
        return (
            <div key={index} className="flex flex-row">
                <div className={props.className}>{`${index + 1}.`}</div>
                <div className={props.className}>{` ${str}`}</div>
            </div>
        )
    });
}
